export enum IdVerificationStatusEnum {
  NOT_REQUIRED = 'NOT_REQUIRED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  PASSED = 'PASSED',
  FAILED = 'FAILED'
}
